export default __webpack_public_path__ + "static/hasura-free-ff60e409244e0ea12b5a3045d1a9096b.png";